import { Component, inject } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { type InvoiceAttachment } from '../../../../models/invoice-attachment';
import { environment } from '../../../../../../environments/environment';
import { Button } from 'primeng/button';
import { type PdfDialogData } from '../../../../models/pdf-dialog-data';

@Component({
    selector: 'app-pdf-selection',
    imports: [Button],
    templateUrl: './pdf-selection.component.html',
    styleUrl: './pdf-selection.component.sass'
})
export class PdfSelectionComponent {
    private ref = inject(DynamicDialogRef);
    private config = inject(DynamicDialogConfig);
    private readonly baseUrl = `https://${environment.netSuiteInstance.subdomain}.app.netsuite.com`;

    private readonly data = this.config.data as PdfDialogData;
    public files: InvoiceAttachment[] = this.data.files;

    public openFile(url: string): void {
        window.open(this.baseUrl + url, '_blank');
    }

    public openAll(): void {
        this.files.forEach(({ url }) => {
            window.open(this.baseUrl + url, '_blank');
        });
        this.close();
    }

    public close(): void {
        this.ref.close();
    }
}
